import { render, staticRenderFns } from "./ApexBarCharts.vue?vue&type=template&id=3e965a88"
import script from "./ApexBarCharts.vue?vue&type=script&lang=js"
export * from "./ApexBarCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports